/**
 * Dealer phone normalization (Dealer Profile M2).
 */
import {
  buildDealerWhatsappUrl as buildWhatsappUrlFromListing,
  buildWhatsappHref,
  isValidWhatsappNumber,
  normalizeWhatsappNumber,
} from "../dealerWhatsapp";

export { buildWhatsappHref };

export function normalizeDealerWhatsapp(rawValue) {
  return normalizeWhatsappNumber(rawValue);
}

export function isValidDealerWhatsapp(value) {
  return isValidWhatsappNumber(normalizeDealerWhatsapp(value));
}

export function normalizeDealerPhone(rawValue) {
  if (rawValue == null || rawValue === "") return null;
  const digits = String(rawValue).replace(/\D/g, "");
  if (!digits) return null;
  if (digits.length === 10 && digits.startsWith("3")) {
    return `+57${digits}`;
  }
  if (digits.startsWith("57") && digits.length === 12) {
    return `+${digits}`;
  }
  if (digits.length >= 10 && digits.length <= 15) {
    return digits.startsWith("+") ? String(rawValue).trim() : `+${digits}`;
  }
  return null;
}

export function isValidDealerPhone(value) {
  const normalized = normalizeDealerPhone(value);
  if (!normalized) return false;
  const digits = normalized.replace(/\D/g, "");
  return digits.length >= 10 && digits.length <= 15;
}

export function buildDealerPhoneHref(dealer) {
  const raw = dealer?.phone || dealer?.mainPhone || null;
  const normalized = normalizeDealerPhone(raw);
  if (!normalized) return null;
  const digits = normalized.replace(/\D/g, "");
  if (digits.length < 10) return null;
  return `tel:+${digits.replace(/^\+/, "")}`;
}

/**
 * @param {{ dealer?: object, listing?: object, message?: string, detailUrl?: string, attribution?: object }} params
 */
export function buildDealerWhatsappUrl({ dealer, listing, message, detailUrl, attribution }) {
  void attribution;
  const profileDealer = dealer
    ? {
        whatsapp: dealer.whatsapp,
        mainWhatsapp: dealer.whatsapp,
        phone: dealer.phone,
      }
    : null;
  return buildWhatsappUrlFromListing({
    dealer: profileDealer,
    listing,
    message,
    detailUrl,
  });
}
